import { action, runInAction } from "mobx"
import messageStore from "../store/index"

class MessageService {
  // 切换Tab
  @action
  handleTabsChange = (tabsValue) => {
    messageStore.tabsValue = tabsValue
  }
}

export default new MessageService()
